import {useState} from 'react';

import {isAWSError} from '@fo/shared-types/typeChecks';
import {AWSError} from '@fo/shared-types';
import Identity, {ForgotPassword} from '../../apis/Identity';

interface UseForgotPasswordResponse {
  error?: string;
  isForgotPasswordSubmitted: boolean;
  isLoading: boolean;
  submit: (formData: ForgotPassword) => Promise<boolean>;
}

const useForgotPassword = (): UseForgotPasswordResponse => {
  const [error, setError] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isForgotPasswordSubmitted, setIsForgotPasswordSubmitted] = useState<boolean>(false);

  const submit = (formData: ForgotPassword): Promise<boolean> => {
    setIsLoading(true);
    setError(undefined);
    return Identity.forgotPassword(formData)
      .then(() => {
        setIsLoading(false);
        setIsForgotPasswordSubmitted(true);
        return true;
      })
      .catch((apiError: AWSError | string) => {
        setIsLoading(false);
        if (isAWSError(apiError)) {
          setError(apiError.code);
        } else {
          setError(apiError);
        }
        return false;
      });
  };

  return {
    error,
    isForgotPasswordSubmitted,
    isLoading,
    submit,
  };
};

export default useForgotPassword;
